<template>
  <NodeEvents v-if="node" :event="node" />
</template>

<script lang="ts" setup>
import type { EventinstanceDefaultFragment } from '#graphql-operations'

defineOptions({
  name: 'PageEventInstanceDefault',
})

definePageMeta({
  // Paths ending in `/register`, `/anmelden`, `/inscrire` and `/registrare` are
  // handled by `EventRegisterFormPage`. Make sure the catch-all [...slug] route
  // does not match these paths.
  validate(route) {
    const lastArg = route.path.split('/').pop() || ''
    return !['register', 'anmelden', 'inscrire', 'registrare'].includes(lastArg)
  },
  name: 'eventinstance-default',
  languageMapping: {
    de: '/de/events/:slug(.*)*',
    fr: '/fr/evenements/:slug(.*)*',
    it: '/it/eventi/:slug(.*)*',
    en: '/en/events/:slug(.*)*',
  },
})

const nuxtRoute = useRoute()

const { data: query } = await useAsyncGraphqlQuery(
  'routeEventinstanceDefault',
  {
    path: nuxtRoute.path,
  },
  {
    transform: (v) => v.data,
    graphqlCaching: {
      client: true,
    },
  },
)

const { entity: node } = await useDrupalRoute<EventinstanceDefaultFragment>(
  query.value,
)

useRouteEntity(node)
setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
